module.exports = __webpack_public_path__ + "static/media/logo-mercado-merced.e8d37840.JPG";